<script>
import axios from '@/utils/axios';
import { vendorsList } from '@/utils/vendor';
import { warehousesList } from '@/utils/warehouse';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Modal } from 'bootstrap';

export default {
  inject: ['setLoading'],
  data() {
    return {
      title: "Inventory",
      text: "Inventory", 
      text1: "Inward Stock", 
      id: '',
      ids: [],  
      vendor_id: '',
      warehouse_id: '',
      selectedTax: null,
      selectedUnit: null,
      vendors: [],
      warehouses: [],
      taxes: [],
      allItems: [],
      items: [
        { item: null, price: 0, qty: 1, amount: 0 }
      ],
      loading: false,
      editorConfig: {},
      editor: ClassicEditor,
      errors: {},
    // Invoice modal fields
    invoiceNumber: '',
    invoiceFiles: [],       
    invoiceFilePreviews: [],
    invoiceErrors: {},
    showInvoiceModal: false,
    };
  },

  computed: {
   totalAmount(){
    return this.items.reduce((sum, row) => sum + row.amount, 0);
   },

   taxAmount() {
     // Item mode - sum taxes from individual items using selectedTax
     return this.items.reduce((sum, row) => {
      const itemTaxRate = row.selectedTax?.rate || 0;
      return sum + (row.amount * itemTaxRate / 100);
     }, 0);
   },

   grandTotal(){
    const discountAmount = 0;
    const shippingAmount = 0;
    return Math.max(0, this.totalAmount - discountAmount) + this.taxAmount + shippingAmount;
   },

  },

  mounted(){  
   this.getTaxes(); 
   this.allVendors();
   this.getAllItems();  
   this.allWarehouses();
  },

 methods: {
   
   async allVendors(){
    this.setLoading(true);
    try{
     const response = await vendorsList();
     this.vendors = response.data.data;   
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   },

   async allWarehouses(){
    this.setLoading(true);
    try{
     const response = await warehousesList();
     this.warehouses = response.data.data;   
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   }, 

   async getAllItems(){
    try{
     const res = await axios.get('/items/dropdown', { params: { inventory_type: 'finish' } });
     this.allItems = res.data.data;
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   },
    
   addItemRow(){
    this.items.push({ item: null, selectedTax: null, selectedUnit: null, price: 0, qty: 1, amount: 0 });
   },
   
   removeItemRow(index){
    if (this.items.length === 1) return;
    this.items.splice(index, 1);
   },

   onItemSelected(index, selectedItem){
    const row = this.items[index];
    if(!selectedItem){
     row.item = null;
     row.selectedTax = null;
     row.selectedUnit = null;
     row.price = 0;
     row.qty = 1;
     row.amount = 0;
     return;
    }
  
    // Preserve the tax_id from the items table
    row.price = parseFloat(selectedItem.price || 0);
    row.qty = 1;
  
    // Set the tax for this item if it exists
    if(selectedItem.tax_id){
     row.selectedTax = this.taxes.find(t => t.id === selectedItem.tax_id);
     row.item.tax = row.selectedTax;
    }else{
     row.selectedTax = null;
     row.item.tax = null;
    }
  
    this.updateAmount(index);
   },

   onItemTaxSelected(index, selectedTax){
    const row = this.items[index];
    row.selectedTax = selectedTax;
    
    // Update the item's tax reference for calculations
    if(selectedTax){   
     row.item = row.item || {};
     row.item.tax = selectedTax;
     row.item.tax_id = selectedTax.id;
    }else{
     if (row.item) {
      row.item.tax = null;
      row.item.tax_id = null;
     }
    }
    // Recalculate amount if needed
    this.updateAmount(index);
   },
   
   onItemUnitSelected(index, selectedUnit){
    const row = this.items[index];
    row.selectedUnit = selectedUnit;  
    if(selectedUnit){
     row.unit = selectedUnit;
    }else{
     row.unit = '';
    }
   },

   updateAmount(index){
    const row = this.items[index];
    row.qty = Math.max(1, parseFloat(row.qty) || 1); 
    const price = parseFloat(row.price) || 0;
    row.amount = row.qty * price;
   },

    async getTaxes(){
     this.setLoading(true);
     try{
      const response = await axios.get('/taxes');
      this.taxes = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

async openInvoiceModal() {
  this.errors = {};

  if (!this.warehouse_id) {
    this.errors.warehouse_id = ['Warehouse is required'];
    return;
  }
  if (!this.vendor_id) {
    this.errors.vendor_id = ['Vendor is required'];
    return;
  }
  const hasEmptyItem = this.items.some(row => !row.item);
  if (hasEmptyItem) {
    this.$swalToast('Please select all items', 'warning');
    return;
  }

  this.invoiceNumber = '';
  this.invoiceFiles = [];
  this.invoiceFilePreviews = [];
  this.invoiceImagePreview = null;
  this.invoiceErrors = {};

  const modalEl = document.getElementById('invoice_modal');
  const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
  modal.show();
},

async processStock() {
  this.invoiceErrors = {};

  if (!this.invoiceNumber) {
    this.invoiceErrors.invoiceNumber = ['Invoice number is required'];
    return;
  }
if (!this.invoiceFiles.length) {
  this.invoiceErrors.invoiceFiles = ['At least one invoice image is required'];
  return;
}

  this.setLoading(true);
  try {
    const formData = new FormData();
    formData.append('vendor_id', this.vendor_id);
    formData.append('warehouse_id', this.warehouse_id);
    formData.append('invoice_number', this.invoiceNumber);
    this.invoiceFiles.forEach(file => {
      formData.append('invoice_files[]', file);
    });
    if (this.selectedTax?.id) formData.append('tax_id', this.selectedTax.id);

    this.items.forEach((row, index) => {
      formData.append(`items[${index}][item_id]`, row.item?.id || '');
      formData.append(`items[${index}][name]`, row.item?.name || '');
      formData.append(`items[${index}][quantity]`, row.qty);
      formData.append(`items[${index}][unit_price]`, row.price);
      if (row.selectedTax?.id) {
        formData.append(`items[${index}][tax_id]`, row.selectedTax.id);
      }
    });

    const response = await axios.post('/inventory/stocks/inward', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    this.$swalToast(response.data.message);
    this.$closeModal('invoice_modal');
    this.resetForm();

  } catch (error) {
    if (error?.type === 'validation') {
      this.errors = {};
      this.invoiceErrors = {};
      Object.keys(error.errors).forEach(key => {
        if (key.startsWith('invoice')) {
          this.invoiceErrors[key] = error.errors[key];
        } else {
          this.errors[key] = error.errors[key];
        }
      });
    } else {
      this.$swalToast(error.message, 'error');
    }
  } finally {
    this.setLoading(false);
  }
},

handleInvoiceImage(event) {
  const files = Array.from(event.target.files || []);
  files.forEach(file => {
    this.invoiceFiles.push(file);
    this.invoiceFilePreviews.push(URL.createObjectURL(file));
  });
 
  event.target.value = '';
},

removeInvoiceFile(index) {
  this.invoiceFiles.splice(index, 1);
  this.invoiceFilePreviews.splice(index, 1);
},

    getItemError(index, field){
     const key = `items.${index}.${field}`;
     return this.errors[key] ? this.errors[key][0] : null;
    },

    getItemAmountDisplay(item) {
     if(this.clientSetting?.tax_type === 'inclusive'){
      return item.amount;
     }else{
      if(item.item?.tax){
       return item.amount * (1 + (item.item.tax.rate / 100));
      }
      return item.amount;
     }
    },

   resetForm() {
    this.id = null;
    this.vendor_id = null;
    this.warehouse_id = null;
    this.items = [{ item: null, selectedTax: null, price: 0, qty: 1, amount: 0}];
    this.errors = {};
   }
  }
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">

      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-4">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center">
          <router-link :to="{name: 'inventory-import'}" class="btn btn-sm btn-info d-flex align-items-center gap-1">
            <i class="ti ti-file-type-csv" style="font-size:14px"></i>Import from CSV
          </router-link>
        </div>
      </div>

      <!-- Warehouse & Vendor Card -->
      <div class="card border-0 mb-3" style="border-radius:12px;border:0.5px solid rgba(0,0,0,0.08) !important">
        <div class="card-header bg-white border-bottom py-2 px-3 d-flex align-items-center gap-2" style="border-color:rgba(0,0,0,0.07) !important">
          <i class="ti ti-building-warehouse text-primary" style="font-size:14px"></i>
          <span class="fw-semibold text-secondary" style="font-size:12px;text-transform:uppercase;letter-spacing:0.05em">Warehouse &amp; Vendor</span>
        </div>
        <div class="card-body px-3 py-3">
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label fw-semibold" style="font-size:12px">Warehouse <span class="text-danger">*</span></label>
              <vue-select v-model="warehouse_id" :options="warehouses"
                :get-option-label="w => `${w.name} - ${w.code}`"
                :reduce="w => w.id" placeholder="Select warehouse" class="vue-select-normal" />
              <div v-if="errors.warehouse_id" class="text-danger mt-1" style="font-size:11px">{{ errors.warehouse_id[0] }}</div>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold" style="font-size:12px">Vendor <span class="text-danger">*</span></label>
              <vue-select v-model="vendor_id" :options="vendors"
                :get-option-label="v => `${v.name} - ${v.code}`"
                :reduce="v => v.id" placeholder="Select vendor" class="vue-select-normal" />
              <div v-if="errors.vendor_id" class="text-danger mt-1" style="font-size:11px">{{ errors.vendor_id[0] }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Items Card -->
      <div class="card border-0 mb-3" style="border-radius:12px;border:0.5px solid rgba(0,0,0,0.08) !important">
        <div class="card-header bg-white border-bottom py-2 px-3 d-flex align-items-center justify-content-between" style="border-color:rgba(0,0,0,0.07) !important">
          <div class="d-flex align-items-center gap-2">
            <i class="ti ti-list-details text-primary" style="font-size:14px"></i>
            <span class="fw-semibold text-secondary" style="font-size:12px;text-transform:uppercase;letter-spacing:0.05em">Items</span>
            <span class="badge rounded-pill" style="background:#E6F1FB;color:#0C447C;font-size:11px;font-weight:500">{{ items.length }}</span>
          </div>
          <a href="javascript:void(0);" class="btn btn-sm d-flex align-items-center gap-1"
            style="font-size:12px;padding:5px 10px;border:0.5px solid #185FA5;color:#185FA5;background:transparent;border-radius:8px"
            @click="addItemRow">
            <i class="ti ti-plus" style="font-size:13px"></i>Add item
          </a>
        </div>
         
        <div class="card-body card-table-wrapper">
        <div class="table-responsive">
          <table class="card-table mb-0" style="font-size:13px">
            <thead style="background:#f8fafc">
              <tr>
                <th class="px-3 py-2" style="font-size:11px;font-weight:600;color:#000;text-transform:uppercase;letter-spacing:0.05em;width:28%">Item</th>
                <th class="px-3 py-2" style="font-size:11px;font-weight:600;color:#000;text-transform:uppercase;letter-spacing:0.05em;width:18%">Tax</th>
                <th class="px-3 py-2" style="font-size:11px;font-weight:600;color:#000;text-transform:uppercase;letter-spacing:0.05em;width:15%">Rate</th>
                <th class="px-3 py-2" style="font-size:11px;font-weight:600;color:#000;text-transform:uppercase;letter-spacing:0.05em;width:10%">Qty</th>
                <th class="px-3 py-2" style="font-size:11px;font-weight:600;color:#000;text-transform:uppercase;letter-spacing:0.05em;width:16%">Amount</th>
                <th class="px-3 py-2" style="width:8%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="index" style="border-bottom:0.5px solid rgba(0,0,0,0.05)">
                <td class="px-3 py-2">
                  <vue-select :options="allItems" label="name" v-model="item.item"
                    :get-option-label="i => `${i.name} - ${i.code ?? i.id}`"
                    @update:modelValue="val => onItemSelected(index, val)" :appendToBody="true" />
                  <div class="text-danger mt-1" style="font-size:11px" v-if="getItemError(index, 'item_id')">{{ getItemError(index, 'item_id') }}</div>
                </td>
                <td class="px-3 py-2">
                  <vue-select :options="taxes" label="name" v-model="item.selectedTax" placeholder="Select tax"
                    @update:modelValue="val => onItemTaxSelected(index, val)" :appendToBody="true" />
                  <div class="text-danger mt-1" style="font-size:11px" v-if="getItemError(index, 'tax_id')">{{ getItemError(index, 'tax_id') }}</div>
                </td>
                <td class="px-3 py-2">
                  <input type="number" class="form-control form-control-sm" v-model.number="item.price" @input="updateAmount(index)" />
                  <div class="text-danger mt-1" style="font-size:11px" v-if="getItemError(index, 'unit_price')">{{ getItemError(index, 'unit_price') }}</div>
                </td>
                <td class="px-3 py-2">
                  <input type="number" class="form-control form-control-sm" v-model.number="item.qty" @input="updateAmount(index)" />
                  <div class="text-danger mt-1" style="font-size:11px" v-if="getItemError(index, 'quantity')">{{ getItemError(index, 'quantity') }}</div>
                </td>
                <td class="px-3 py-2">
                  <input type="text" class="form-control form-control-sm"
                    :value="getItemAmountDisplay(item).toFixed(2)" readonly
                    style="background:#f8fafc;color:#64748b" />
                </td>
                <td class="px-3 py-2">
                  <button type="button" class="btn btn-sm" style="border:0.5px solid rgba(0,0,0,0.1);color:#dc2626;padding:5px 8px;border-radius:8px" @click="removeItemRow(index)">
                    <i class="ti ti-trash" style="font-size:13px"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        </div>

        <!-- Totals -->
        <div class="d-flex justify-content-end p-3" style="background: #f1f5f9;">
          <div style="min-width:210px;border:0.5px solid rgba(0,0,0,0.08);border-radius:8px;overflow:hidden;font-size:13px;background: #fff;" >
            <div class="d-flex justify-content-between px-3 py-2" style="border-bottom:0.5px solid rgba(0,0,0,0.06)">
              <span class="text-secondary">Subtotal</span><span>{{ totalAmount.toFixed(2) }}</span>
            </div>
            <div class="d-flex justify-content-between px-3 py-2" style="border-bottom:0.5px solid rgba(0,0,0,0.06)">
              <span class="text-secondary">Tax</span><span>{{ taxAmount.toFixed(2) }}</span>
            </div>
            <div class="d-flex justify-content-between px-3 py-2 fw-semibold" style="background:#f8fafc">
              <span>Grand Total</span><span class="text-primary">{{ grandTotal.toFixed(2) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Bar -->
      <div class="d-flex align-items-center justify-content-between p-3"
        style="background:#fff;border:0.5px solid rgba(0,0,0,0.08);border-radius:12px;margin-bottom:16px">
        <a href="javascript:void(0);" class="btn btn-sm d-flex align-items-center gap-1"
          style="font-size:12px;color:#64748b;border:0.5px solid rgba(0,0,0,0.1);border-radius:8px"
          @click="addItemRow">
          <i class="ti ti-plus" style="font-size:13px"></i>Add item
        </a>
        <button type="button" class="btn btn-primary d-flex align-items-center gap-1" @click="openInvoiceModal">
          <i class="ti ti-device-floppy" style="font-size:14px"></i>Save &amp; Process
        </button>
      </div>

    </div>
    <app-footer></app-footer>
  </div>

  <!-- Invoice Modal -->
  <div class="modal fade" id="invoice_modal" tabindex="-1" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content" style="border:0.5px solid rgba(0,0,0,0.1);border-radius:12px;overflow:hidden">
        <div class="modal-header border-bottom py-3 px-4" style="border-color:rgba(0,0,0,0.07) !important">
          <h5 class="modal-title d-flex align-items-center gap-2" style="font-size:15px">
            <i class="ti ti-file-invoice text-primary" style="font-size:16px"></i>Invoice Details
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body px-4 py-3">
          <p class="rounded py-2 px-3 mb-3" style="font-size:12px;color:#64748b;background:#f8fafc;border:0.5px solid rgba(0,0,0,0.06)">
            Provide invoice details before processing this inward stock entry.
          </p>
          <div class="mb-3">
            <label class="form-label fw-semibold" style="font-size:12px">Invoice number <span class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="invoiceNumber" placeholder="e.g. INV-2024-00123" />
            <div v-if="invoiceErrors.invoiceNumber" class="text-danger mt-1" style="font-size:11px">{{ invoiceErrors.invoiceNumber[0] }}</div>
          </div>
          <div class="mb-2">
            <label class="form-label fw-semibold" style="font-size:12px">Invoice image <span class="text-danger">*</span></label>
            <label class="d-flex flex-column align-items-center justify-content-center py-4 rounded"
              style="border:1.5px dashed rgba(0,0,0,0.15);background:#f8fafc;cursor:pointer;gap:6px">
              <i class="ti ti-upload text-secondary" style="font-size:22px"></i>
              <span style="font-size:12px;color:#475569">Click to upload or drag &amp; drop</span>
              <span style="font-size:11px;color:#94a3b8">PNG, JPG, PDF up to 5MB</span>
              <input type="file" class="d-none" accept="image/*" multiple @change="handleInvoiceImage" />
              </label>
              <div v-if="invoiceErrors.invoiceFiles" class="text-danger mt-1" style="font-size:11px">{{ invoiceErrors.invoiceFiles[0] }}</div>
              <div v-if="invoiceFilePreviews.length" class="mt-2 d-flex flex-wrap gap-2">
                <div v-for="(preview, idx) in invoiceFilePreviews" :key="idx" style="position:relative;">
                  <img :src="preview" class="img-thumbnail" style="max-height:100px" />
                  <button type="button" class="btn btn-sm btn-danger"
                    style="position:absolute;top:-6px;right:-6px;padding:1px 5px;border-radius:50%;font-size:10px;"
                    @click="removeInvoiceFile(idx)">
                    <i class="ti ti-x"></i>
                  </button>
                </div>
              </div>
          </div>
        </div>
        <div class="modal-footer border-top py-2 px-4 gap-2" style="border-color:rgba(0,0,0,0.07) !important">
          <button type="button" class="btn btn-light btn-sm" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary btn-sm d-flex align-items-center gap-1"
            @click="processStock" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            <i v-else class="ti ti-check" style="font-size:13px"></i>
            Process Stock
          </button>
        </div>
      </div>
    </div>
  </div>
</template>